export enum StructuredOperationAssetsSubtypesEnum {
  CCB = 1,
  CRA = 2,
  CRI = 3,
  Debenture = 4,
  Realty = 5,
  JudicialActions = 7,
  Precatory = 8,
  PublicCompany = 9,
  ClosedCompany = 10,
  LimitedCompany = 11,
  SpecialPurposeEntity = 12,
}
